'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function (darc) {
  var Type = function Type(value) {
    _classCallCheck(this, Type);

    this.name = value.name;
    this.value = value;
  };

  Type.from = function (type) {
    if (type instanceof darc.classes.Type) {
      return type;
    } else {
      return new darc.classes.Type(type);
    }
  };

  return Type;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NvdXJjZS9jbGFzc2VzL1R5cGUuanMiXSwibmFtZXMiOlsibW9kdWxlIiwiZXhwb3J0cyIsIlR5cGUiLCJ2YWx1ZSIsIm5hbWUiLCJmcm9tIiwidHlwZSIsImRhcmMiLCJjbGFzc2VzIl0sIm1hcHBpbmdzIjoiQUFBQTs7OztBQUNBQSxPQUFPQyxPQUFQLEdBQWlCLGdCQUFRO0FBRXhCLE1BQUlDLE9BRUgsY0FBYUMsS0FBYixFQUFxQjtBQUFBOztBQUVwQixTQUFLQyxJQUFMLEdBQVlELE1BQU1DLElBQWxCO0FBQ0EsU0FBS0QsS0FBTCxHQUFhQSxLQUFiO0FBRUEsR0FQRjs7QUFXQUQsT0FBS0csSUFBTCxHQUFZLGdCQUFRO0FBRW5CLFFBQUtDLGdCQUFnQkMsS0FBS0MsT0FBTCxDQUFhTixJQUFsQyxFQUF5QztBQUV4QyxhQUFPSSxJQUFQO0FBRUEsS0FKRCxNQUlPO0FBRU4sYUFBTyxJQUFJQyxLQUFLQyxPQUFMLENBQWFOLElBQWpCLENBQXVCSSxJQUF2QixDQUFQO0FBRUE7QUFFRCxHQVpEOztBQWNBLFNBQU9KLElBQVA7QUFFQSxDQTdCRCIsInNvdXJjZXNDb250ZW50IjpbIid1c2Ugc3RyaWN0Jztcbm1vZHVsZS5leHBvcnRzID0gZGFyYyA9PiB7XG5cblx0bGV0IFR5cGUgPSBjbGFzcyBUeXBlIHtcblxuXHRcdGNvbnN0cnVjdG9yKCB2YWx1ZSApIHtcblxuXHRcdFx0dGhpcy5uYW1lID0gdmFsdWUubmFtZTtcblx0XHRcdHRoaXMudmFsdWUgPSB2YWx1ZTtcblxuXHRcdH1cblxuXHR9O1xuXG5cdFR5cGUuZnJvbSA9IHR5cGUgPT4ge1xuXG5cdFx0aWYgKCB0eXBlIGluc3RhbmNlb2YgZGFyYy5jbGFzc2VzLlR5cGUgKSB7XG5cblx0XHRcdHJldHVybiB0eXBlO1xuXG5cdFx0fSBlbHNlIHtcblxuXHRcdFx0cmV0dXJuIG5ldyBkYXJjLmNsYXNzZXMuVHlwZSggdHlwZSApO1xuXG5cdFx0fVxuXG5cdH07XG5cblx0cmV0dXJuIFR5cGU7XG5cbn07XG4iXX0=